import React from 'react';

const FamilyScaleCircle: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <circle cx="64" cy="64" r="57" stroke="#fff" strokeWidth="4"></circle>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M38.952 82.208h49.494M73.633 95.033H52.92l4.26-9.235h12.185l4.269 9.235z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M49.647 91.71l3.442-4.802"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M42.498 81.986V76.36c-2.673 0-4.1-1.591-4.1-3.59l-.027-12.445c0-6.412 2.804-9.022 8.105-9.373l4.212 3.46 4.221-3.46c1.886.12 4.484.85 6.154 2.498M43.765 41.329c0 3.775 3.105 6.837 6.932 6.837 3.828 0 6.933-3.062 6.933-6.837 0-3.776-3.105-6.829-6.933-6.829-3.827 0-6.932 3.053-6.932 6.829zm39.868 0c0-3.776-3.105-6.829-6.932-6.829-3.827 0-6.932 3.053-6.932 6.829 0 3.775 3.105 6.837 6.932 6.837 3.828 0 6.933-3.062 6.933-6.837z"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M63.502 53.006c-3.79 0-6.857 3.035-6.857 6.773 0 3.738 3.077 6.764 6.857 6.764 3.781 0 6.867-3.026 6.867-6.764 0-3.738-3.077-6.773-6.867-6.773zm12.064 28.98v-4.969c0-4.293-3.208-7.162-7.73-8.254l-4.334 3.378-4.474-3.48c-4.447.861-7.59 3.276-7.59 8.365v4.97"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M84.9 81.986V76.36c2.673 0 4.1-1.591 4.1-3.59l.027-12.445c0-6.412-2.805-9.022-8.105-9.373l-4.212 3.46-4.221-3.46c-1.886.12-4.484.85-6.154 2.498"
    ></path>
  </svg>
);

export default FamilyScaleCircle;
